import classNames from 'classnames'

import { THEME_PREFERENCES, ThemePreference } from '../../../common/types/theme.js'
import { Monitor, Moon, Sun } from '../icon/solar-icons.js'
import './theme-switch.css'

export interface ThemeSwitchProps {
    value: ThemePreference
    /** `origin` on klikitud nupu keskpunkt viewportis — teemavahetuse ring-laine algus. */
    onChange: (pref: ThemePreference, origin: { x: number; y: number }) => void
    labels: Record<ThemePreference, string>
    /** `compact` näitab ainult ikoone (kasutajamenüü), `regular` ikooni + silti. */
    size?: 'compact' | 'regular'
    /** `chrome` = tumeda navi/hero sees (chrome-tokenid), `default` = tavaline pind. */
    tone?: 'default' | 'chrome'
}

const ICONS = { system: Monitor, light: Sun, dark: Moon } as const

/** Kolme segmendiga teemavalik: süsteem / hele / tume. Props-only, state tuleb väljast. */
export const ThemeSwitch = ({
    value,
    onChange,
    labels,
    size = 'regular',
    tone = 'default',
}: ThemeSwitchProps) => (
    <div
        className={classNames(
            'theme-switch',
            `theme-switch--${size}`,
            tone === 'chrome' && 'theme-switch--on-chrome',
        )}
        role="radiogroup"
    >
        {THEME_PREFERENCES.map((pref) => {
            const Icon = ICONS[pref]
            return (
                <button
                    key={pref}
                    type="button"
                    role="radio"
                    aria-checked={value === pref}
                    aria-label={labels[pref]}
                    title={labels[pref]}
                    className={classNames('theme-switch__option', value === pref && 'is-active')}
                    onClick={(e) => {
                        const r = e.currentTarget.getBoundingClientRect()
                        onChange(pref, { x: r.left + r.width / 2, y: r.top + r.height / 2 })
                    }}
                >
                    <Icon size={16} aria-hidden="true" />
                    <span className="theme-switch__label">{labels[pref]}</span>
                </button>
            )
        })}
    </div>
)
